import React from "react"
import CodeBlock from "~components/CodeBlock"

const Response = ({ explorer, microcopy }) => (
  <>
    <h3>{microcopy.text("explorer.titles.body")}</h3>
    <CodeBlock
      language="json"
      code={explorer.renderedResponse}
      success={explorer.success}
    />
  </>
)

export default Response
